var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 612,
    viewBox: "0 0 612 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.152 11.1391C293.98 -3.71301 318.02 -3.71303 332.848 11.139L600.174 278.903C615.002 293.755 615.002 317.835 600.174 332.688L332.848 600.452C318.02 615.304 293.98 615.304 279.152 600.452L11.8258 332.688C-3.00195 317.835 -3.00196 293.755 11.8258 278.903L279.152 11.1391Z",
    fill: "url(#paint0_linear_7_131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.766 603.224C314.857 615.238 292.992 614.314 279.152 600.452L11.8258 332.688C-3.00195 317.835 -3.00195 293.756 11.8258 278.903L185.355 105.09C205.606 113.19 224.519 125.585 240.686 142.254L409.87 316.684C455.962 364.206 466.654 432.981 442.444 490.361L329.766 603.224Z",
    fill: "url(#paint1_linear_7_131)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.636 553.86L11.8258 332.688C-3.00195 317.835 -3.00196 293.756 11.8258 278.903L131.88 158.653C216.791 147.155 295.244 173.13 336.03 234.756C397.483 327.606 351.029 467.536 232.636 553.86Z",
    fill: "url(#paint2_linear_7_131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.654 481.76L11.8258 332.688C-3.00195 317.835 -3.00195 293.756 11.8258 278.903L223.352 67.0301C339.128 152.826 382.027 294.853 318.504 393.264C284.487 445.963 226.506 476.001 160.654 481.76Z",
    fill: "url(#paint3_linear_7_131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_131",
    x1: 305.642,
    y1: 24.241,
    x2: 505.432,
    y2: 393.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85F41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_131",
    x1: 240,
    y1: 549.5,
    x2: 455,
    y2: 413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC276C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_131",
    x1: 365.295,
    y1: 297.116,
    x2: -108.705,
    y2: 576.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475177",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_131",
    x1: 46,
    y1: 296,
    x2: 344.325,
    y2: 487.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EBBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365D96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fcc47ab5bd6901c43bcc39afd5842483.svg";
export { ForwardRef as ReactComponent };